import { PrintTechnology, Spread } from '../design/types';

const shouldDigitizeSpread = (spread: Spread): boolean => spread.technology === PrintTechnology.Embroidery;

export default shouldDigitizeSpread;
